const matchApi = {
  QUERYMATCHLIST: '/matchAwardsRecordDo/itemList', //赛事管理获取所有赛事
  GETALLMATCHLIST: '/matchEvent/getAllCompetition', //获取所有赛事
  ADDSESSION: '/matchAwardsRecordDo/addsession', //添加届数
  GETSTUDENTMATCHDATA: '/matchAttendanceDo/getAttendByMatchId', //赛事管理详情
  //参赛者
  ADDATTENDDATA: '/matchAttendanceDo/addAttendRecord', //添加参赛人信息
  DELECTATTENDDATA: '/matchAttendanceRecord/deleteById', //删除个人参加的赛事
  UPDATEATTENDDATA: '/matchAttendanceDo/updateAttendRecord', //修改个人参加的赛事
  GETQUERYMATCHALL: '/matchEvent/queryPCMatches', //获取赛事维护的所有数据
  ADDMATCHLISINALL: '/matchEvent/addMatches', // 添加赛事到维护赛事
  UPDATAMATCHLISINALL: '/matchEvent/updateMatch', // 添加赛事到维护赛事
  DELECTMATCHLISINALL: '/matchEvent/deleteMatch', // 删除赛事到维护赛事
  GTEQALISTDATA: '/repository/getAll', //获取所有问答
  ADDQALISTITEM: '/repository/addRepository', //添加一个问答 入参
  UPDATEQALISTITEM: '/repository/updateRepository', //更新一个问答 入参
  DELETEQALISTITEM: '/repository/deleteRepository', //删除一个问答 入参
  DELETEPRIZEINFO: '/matchAwardsRecordDo/deletePrizeInfo', //删除一个问答 入参
  ADDPRIZEINFO: '/matchAwardsRecordDo/addPrizeInfo', //添加某个学校某一届的获奖信息
  //2021/01/18接口功能新增
  GETATTACHMENTLIST: '/matchAttendanceDo/attachmentList', //获取项目维护数据列表
  GETTEACHERORSTUDENT: '/matchAttendanceDo/getItemMember', //获取项目成员和导师
  DELECTATTACHMENTITEM: '/matchAttendanceDo/deleteAttend', //删除参赛人信息
  GETMATCHTYPEAPI: '/matchTypeDict/getMatchType', //获取赛事类型信息
  GETALLMATCHTYPES: '/matchTypeDict/getTypeNames', //获取全部赛事分类,赛事类别数据
  GETYEARS: '/matchAwardsRecordDo/getYears', //获取筛选的年份
  GETSESSION: '/matchAwardsRecordDo/getSession', //获取赛事的届数
  ADDMATCHPALF: '/matchAttendanceDo/addAttendRecord', //添加参赛人信息--一部分
  GETROLES: '/studentRole/getRoleByType', //获取老师学生的身份角色
  DELECTMEMBER: '/matchStudentMapping/deleteMember', //删除项目成员
  SEARCHMEMBER: '/student/getMemberByRole', //模糊查询添加用户，
  ADDMEMBER: '/matchStudentMapping/addMember', //添加项目成员,
  EDITMEMBER: '/matchStudentMapping/updateMember', //编辑项目成员
  GETDETAILDATA: '/matchAttendanceDo/getAttend', //查询单个项目
  UPDATEMATCHITEM: '/matchAttendanceDo/updateAttendRecord', //更新参赛人信息
  EXPORTFILEMATCH: '/matchAttendanceDo/export', //导出项目
  GETAWARDDATA: '/matchAttendanceDo/getAwards', //获取参赛获奖记录
  CHANGEGETAWARD: '/matchAttendanceRecord/updateMatchTrack', //修改获奖信息
  GETALLJOBS: '/matchFieldDict/getAllField',//获取全部领域
  BATCHUPDATE: '/matchAttendanceDo/batchUpdate',
  NAMELISTEXPORT: '/matchAttendanceDo/recordExport',
  GETMATCHTRAINDATA: '/matchEventTraining/queryTrainingByMatchEventId',//通过赛事id查询相关训练营 {id赛事id trainCampName:训练营标题}
  DELETETRAINITEM: '/matchEventTraining/deleteTrainingById',//删除训练营 {id}
  UPDATETRAINITEM: '/matchEventTraining/updateTrainingById',//修改训练营
  ADDTRAINITEN: '/matchEventTraining/addTraining',//添加赛事训练营 
  DELETESESSION: '/matchAwardsRecordDo/deleteSession',
  DELETEAWARD: '/matchAttendanceDo/deleteAwardById'
}

export default matchApi
//    // this.addApplyListForm.resetFields()
// this.$notification.open({
//   type: 'success',
//   message: '添加申请条件',
//   description: '添加成功'
// })operationFlag
// console.log(this.$route.query.id)
//btnEdit btnDelect QATableData btnQADelect btnQAEdit
